// import { useEffect, useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import "../css/navbar.css";
// import { useSelector } from "react-redux";

// export default function Navbar() {
//   const [auth, setAuth] = useState("");
//   const [showAdmin, setshowAdmin] = useState("none");
//   const [clicks, setClicks] = useState(1);
//   const [index, setIndex] = useState(0);
//   const [fade, setFade] = useState(true);
//   const path = useLocation().pathname;
//   const navigate = useNavigate();

//   const messages = [
//     { text: "Click here to fill out the help form", dir: "ltr" },
//     { text: "مدد کے لیے فارم بھرنے کے لیے یہاں کلک کریں", dir: "rtl" },
//     { text: "सहायता फॉर्म भरने के लिए यहाँ क्लिक करें", dir: "ltr" },
//   ];

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setFade(false);
//       setTimeout(() => {
//         setIndex((prev) => (prev + 1) % messages.length);
//         setFade(true);
//       }, 500);
//     }, 7000);
//     return () => clearInterval(interval);
//   }, []);

//   const currentTheme = useSelector((state) => state.theme.current);

//   function displayAdmin() {
//     setClicks((prev) => prev + 1);
//     if (clicks >= 7) {
//       setshowAdmin("flex");
//       navigate("/admin");
//     }
//   }

//   useEffect(() => {
//     const isAdmin = localStorage.getItem("ADMIN_NGO");
//     const isUser = localStorage.getItem("NGO");
//     if (isAdmin) setAuth("ADMIN");
//     else if (isUser) setAuth("USER");
//     window.scrollTo({ top: 0, behavior: "smooth" });

//     const topBar = document.querySelector(".top-bar");
//     const navbar = document.querySelector(".navbar");

//     function toggleStickyNavbar() {
//       if (window.scrollY > topBar.offsetHeight) {
//         if (currentTheme === "#000000") navbar.classList.add("nav-stickyblack");
//         else if (currentTheme === "#381317") navbar.classList.add("nav-stickyred");
//         else navbar.classList.add("nav-stickygreen");
//         topBar.classList.add("hide-top-bar");
//       } else {
//         navbar.classList.remove("nav-stickyblack", "nav-stickyred", "nav-stickygreen");
//         topBar.classList.remove("hide-top-bar");
//       }
//     }

//     window.addEventListener("scroll", toggleStickyNavbar);
//     return () => window.removeEventListener("scroll", toggleStickyNavbar);
//   }, []);

//   return (
//     <div>
//       {/* Warning message for mobile devices */}
//       <div
//         className="mobile-warning d-block d-md-none"
//         style={{ backgroundColor: `${currentTheme}` }}
//       >
//         <div>
//           <p
//             style={{ color: "#FFC324", fontSize: "1rem" }}
//             onClick={() => displayAdmin()}
//           >
//             ⚠️ Currently, we are available in Mumbai only!!
//           </p>
//         </div>
//       </div>

//       {/* Top Bar */}
//       <div
//         style={{ background: `${currentTheme}` }}
//         className="top-bar d-none d-md-block"
//       >
//         <div className="container-fluid">
//           <div className="row">
//             <div className="col-md-8">
//               <div className="top-bar-left">
//                 <div className="text" style={{ display: showAdmin }}>
//                   <Link to="/admin">
//                     <i title="ADMIN" className="fa fa-solid fa-user-tie m-0" style={{ fontSize: "21px" }} />
//                   </Link>
//                 </div>
//                 <div className="text">
//                   <i className="fa fa-phone"></i>
//                   <a href="tel:+91-7400231537"><p>+91-7400231537</p></a>
//                 </div>
//                 <div className="text">
//                   <i className="fa fa-phone"></i>
//                   <a href="tel:+91-7738805577"><p>+91-7738805577</p></a>
//                 </div>
//                 <div className="text">
//                   <i className="fa fa-envelope"></i>
//                   <a href="mailto:alqaimwelfareinfo@gmail.com"><p>alqaimwelfareinfo@gmail.com</p></a>
//                 </div>
//                 <div className="text warning-text">
//                   <p style={{ color: "#FFC324 " }} onClick={() => displayAdmin()}>
//                     ⚠️ Currently, we are available in Mumbai only!!
//                   </p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-4">
//               <div className="top-bar-right">
//                 <div className="social">
//                   <a href="https://www.facebook.com/profile.php?id=61567726026527&mibextid=ZbWKwL">
//                     <i className="fab fa-facebook-f"></i>
//                   </a>
//                   <a href="https://www.instagram.com/al.qaim_welfare/profilecard/?igsh=OXpjZ3Y3bTExbnE3">
//                     <i className="fab fa-instagram"></i>
//                   </a>
//                   <a href="https://www.threads.net/@al.qaim_welfare?invite=0">
//                     <i className="fab fa-threads"></i>
//                   </a>
//                   <a href="https://www.youtube.com/@AlQaimWelfareFoundation?target=_blank">
//                     <i className="fab fa-youtube"></i>
//                   </a>
//                 </div>
//                 {auth.length > 0 && (
//                   <button
//                     onClick={() => {
//                       auth === "USER"
//                         ? localStorage.removeItem("NGO")
//                         : localStorage.removeItem("ADMIN_NGO");
//                       setAuth("");
//                       navigate("/");
//                     }}
//                     type="button"
//                     className="btn btn-outline-danger"
//                   >
//                     LOGOUT {auth}
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Navbar */}
//       <div
//         className="navbar navbar-expand-lg navbar-dark"
//         style={{ background: `${currentTheme}` }}
//       >
//         <div className="container-fluid">
//           <Link to="/" className="navbar-brand">
//             <h2>Al Qaim Welfare Foundation...</h2>
//           </Link>
//           <div className="navbar-nav">
//             <Link to="/" className="nav-item nav-link">Home</Link>

//             <div className="nav-item dropdown-about">
//               <Link
//                 to="/knowMore"
//                 className={`nav-item nav-link ${path === "/about" ? "active" : ""}`}
//               >
//                 About&nbsp;<i className="fa fa-caret-down" />
//               </Link>
//               <div className="dropdown-about-menu">
//                 <Link className="dropdown-about-item" to="/wam">
//                   want to become aqwf member?
//                 </Link>
//               </div>
//             </div>

//             <Link to="/event" className="nav-item nav-link">Sermons</Link>
//             <Link to="/donate" className="nav-item nav-link">DonateNow</Link>

//             {/* ── NeedHelp Dropdown ── */}
//             <div className="nav-item dropdown-needhelp">
//               <div className="help-wrapper">
//                 <div className="help-tooltip">
//                   <span
//                     style={{
//                       transition: "opacity 0.5s ease",
//                       opacity: fade ? 1 : 0,
//                       direction: messages[index].dir,
//                       display: "inline-block",
//                     }}
//                   >
//                     {messages[index].text}
//                   </span>
//                   <div className="arrow"></div>
//                 </div>
//                 <Link
//                   to="/needhelp"
//                   className={`nav-item nav-link ${path === "/needhelp" ? "active" : ""}`}
//                 >
//                   NeedHelp&nbsp;<i className="fa fa-caret-down" />
//                 </Link>
//               </div>
//               <div className="dropdown-needhelp-menu">
//                 <Link className="dropdown-needhelp-item" to="/needhelp">
//                   🏥 Need Help (Medical / Education / Ration)
//                 </Link>
//                 <Link className="dropdown-needhelp-item" to="/sadqa-box">
//                   📦 Collect Sadqah Box
//                 </Link>
//                 <Link className="dropdown-needhelp-item" to="/member-agreement">
//                   🤝 Become a Member
//                 </Link>
//                 <Link className="dropdown-needhelp-item" to="/volunteer-agreement">
//                   🙋 Become a Volunteer
//                 </Link>
//               </div>
//             </div>

//             <Link to="/contact" className="nav-item nav-link">Contact</Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../css/navbar.css";
import { useSelector } from "react-redux";

export default function Navbar() {
  const [auth,       setAuth]       = useState("");
  const [showAdmin,  setShowAdmin]  = useState("none");
  const [clicks,     setClicks]     = useState(1);
  const [index,      setIndex]      = useState(0);
  const [fade,       setFade]       = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const path         = useLocation().pathname;
  const navigate     = useNavigate();
  const currentTheme = useSelector((state) => state.theme.current);

  const messages = [
    { text: "Click here to fill out the help form", dir: "ltr" },
    { text: "مدد کے لیے فارم بھرنے کے لیے یہاں کلک کریں", dir: "rtl" },
    { text: "सहायता फॉर्म भरने के लिए यहाँ क्लिक करें", dir: "ltr" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => { setIndex((p) => (p + 1) % messages.length); setFade(true); }, 500);
    }, 7000);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.body.style.overflow = drawerOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [drawerOpen]);

  useEffect(() => { setDrawerOpen(false); }, [path]);

  function displayAdmin() {
    setClicks((p) => p + 1);
    if (clicks >= 4) { setShowAdmin("flex"); navigate("/admin"); }
  }

  useEffect(() => {
    const isAdmin = localStorage.getItem("ADMIN_NGO");
    const isUser  = localStorage.getItem("NGO");
    if (isAdmin) setAuth("ADMIN");
    else if (isUser) setAuth("USER");
    window.scrollTo({ top: 0, behavior: "smooth" });

    const topBar = document.querySelector(".top-bar");
    const navbar = document.querySelector(".navbar");
    if (!topBar || !navbar) return;

    function toggleSticky() {
      if (window.scrollY > topBar.offsetHeight) {
        if (currentTheme === "#000000") navbar.classList.add("nav-stickyblack");
        else if (currentTheme === "#381317") navbar.classList.add("nav-stickyred");
        else navbar.classList.add("nav-stickygreen");
        topBar.classList.add("hide-top-bar");
      } else {
        navbar.classList.remove("nav-stickyblack","nav-stickyred","nav-stickygreen");
        topBar.classList.remove("hide-top-bar");
      }
    }
    window.addEventListener("scroll", toggleSticky);
    return () => window.removeEventListener("scroll", toggleSticky);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleLogout = () => {
    if (auth === "USER") localStorage.removeItem("NGO");
    else localStorage.removeItem("ADMIN_NGO");
    setAuth("");
    navigate("/");
  };

  return (
    <div>
      {/* ── Mobile warning bar ── */}
      <div className="mobile-warning d-block d-md-none" style={{ backgroundColor: currentTheme }}>
        <p style={{ color:"#FFC324", fontSize:"1rem" }} onClick={displayAdmin}>
          ⚠️ Currently, we are available in Mumbai only!!
        </p>
      </div>

      {/* ── Top Bar (desktop only) ── */}
      <div style={{ background: currentTheme }} className="top-bar d-none d-md-block">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="top-bar-left">
                <div className="text" style={{ display: showAdmin }}>
                  <Link to="/admin"><i title="ADMIN" className="fa fa-solid fa-user-tie m-0" style={{ fontSize:"21px" }} /></Link>
                </div>
                <div className="text"><i className="fa fa-phone"></i><a href="tel:+91-7400231537"><p>+91-7400231537</p></a></div>
                <div className="text"><i className="fa fa-phone"></i><a href="tel:+91-7738805577"><p>+91-7738805577</p></a></div>
                <div className="text"><i className="fa fa-envelope"></i><a href="mailto:alqaimwelfareinfo@gmail.com"><p>alqaimwelfareinfo@gmail.com</p></a></div>
                <div className="text warning-text"><p style={{ color:"#FFC324" }} onClick={displayAdmin}>⚠️ Currently, we are available in Mumbai only!!</p></div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="top-bar-right">
                <div className="social">
                  <a href="https://www.facebook.com/profile.php?id=61567726026527&mibextid=ZbWKwL"><i className="fab fa-facebook-f"></i></a>
                  <a href="https://www.instagram.com/al.qaim_welfare/profilecard/?igsh=OXpjZ3Y3bTExbnE3"><i className="fab fa-instagram"></i></a>
                  <a href="https://www.threads.net/@al.qaim_welfare?invite=0"><i className="fab fa-threads"></i></a>
                  <a href="https://www.youtube.com/@AlQaimWelfareFoundation?target=_blank"><i className="fab fa-youtube"></i></a>
                  <a href="https://whatsapp.com/channel/0029Vb8U49IG3R3b3NaFGv3c?target=_blank"><i className="fab fa-whatsapp"></i></a>
                </div>
                {auth.length > 0 && (
                  <button onClick={handleLogout} type="button" className="btn btn-outline-danger">LOGOUT {auth}</button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Desktop Navbar ── */}
      <div className="navbar navbar-expand-lg navbar-dark" style={{ background: currentTheme }}>
        <div className="container-fluid">
          <Link to="/" className="navbar-brand"><h2>Al Qaim Welfare Foundation...</h2></Link>

          {/* Desktop links — hidden on mobile, hamburger shown instead */}
          <div className="navbar-nav d-none d-md-flex">
            <Link to="/" className="nav-item nav-link">Home</Link>

            <div className="nav-item dropdown-about">
              <Link to="/knowMore" className={"nav-item nav-link" + (path === "/about" ? " active" : "")}>
                About&nbsp;<i className="fa fa-caret-down" />
              </Link>
              <div className="dropdown-about-menu">
                <Link className="dropdown-about-item" to="/wam">want to become aqwf member?</Link>
              </div>
            </div>

            <Link to="/event" className="nav-item nav-link">Sermons</Link>
            <Link to="/donate" className="nav-item nav-link">DonateNow</Link>

            <div className="nav-item dropdown-needhelp">
              <div className="help-wrapper">
                <div className="help-tooltip">
                  <span style={{ transition:"opacity 0.5s ease", opacity: fade ? 1 : 0, direction: messages[index].dir, display:"inline-block" }}>
                    {messages[index].text}
                  </span>
                  <div className="arrow"></div>
                </div>
                <Link to="/needhelp" className={"nav-item nav-link" + (path === "/needhelp" ? " active" : "")}>
                  NeedHelp&nbsp;<i className="fa fa-caret-down" />
                </Link>
              </div>
              <div className="dropdown-needhelp-menu">
                <Link className="dropdown-needhelp-item" to="/needhelp"> Need Help (Medical / Education / Ration)</Link>
                <Link className="dropdown-needhelp-item" to="/sadqa-box"> Get Sadqah Box</Link>
                <Link className="dropdown-needhelp-item" to="/member-agreement"> Become a Member</Link>
                <Link className="dropdown-needhelp-item" to="/volunteer-agreement"> Become a Volunteer</Link>
              </div>
            </div>

            <Link to="/contact" className="nav-item nav-link">Contact</Link>
          </div>

          {/* Hamburger — mobile only */}
          <button
            className="nav-hamburger d-flex d-md-none"
            onClick={() => setDrawerOpen(true)}
            aria-label="Open menu"
          >
            <span className="ham-line"></span>
            <span className="ham-line"></span>
            <span className="ham-line"></span>
          </button>
        </div>
      </div>

      {/* ── Mobile Drawer Overlay ── */}
      <div
        className={"drawer-overlay" + (drawerOpen ? " drawer-overlay-show" : "")}
        onClick={() => setDrawerOpen(false)}
      />

      {/* ── Mobile Drawer ── */}
      <div className={"mobile-drawer" + (drawerOpen ? " drawer-open" : "")} style={{ background: currentTheme }}>
        {/* Header */}
        <div className="drawer-header">
          <span className="drawer-title">﷽ Al-Qaim Welfare Foundation</span>
          <button className="drawer-close-btn" onClick={() => setDrawerOpen(false)}>✕</button>
        </div>

        {/* Nav Links */}
        <nav className="drawer-nav">
          <Link to="/" className={"drawer-link" + (path === "/" ? " drawer-active" : "")}>🏠 Home</Link>
          <Link to="/knowMore" className="drawer-link">➡️  About Us</Link>
          <Link to="/wam" className="drawer-link">➡️  Want to Become AQWF Member?</Link>
                    <Link to="/sadqa-box" className="drawer-link">➡️  Get Sadqah Box</Link>
          <Link to="/member-agreement" className="drawer-link">➡️  Become a Member</Link>
          <Link to="/volunteer-agreement" className="drawer-link">➡️  Become a Volunteer</Link>

          <div className="drawer-divider" />

          <Link to="/event" className={"drawer-link" + (path === "/event" ? " drawer-active" : "")}>➡️  Sermons</Link>
          <Link to="/donate" className={"drawer-link" + (path === "/donate" ? " drawer-active" : "")}>💚  Donate Now</Link>
          <Link to="/contact" className={"drawer-link" + (path === "/contact" ? " drawer-active" : "")}>📞  Contact</Link>

          <div className="drawer-divider" />
          <div className="drawer-section-label">Need Help? Click Below 👇</div>

          <Link to="/needhelp" className="drawer-link">💚  Need Help</Link>
        </nav>

        {/* Footer */}
        <div className="drawer-footer">
          {/* <a href="tel:+91-7400231537" className="drawer-contact-link">📞 +91-7400231537</a>
          <a href="tel:+91-7738805577" className="drawer-contact-link">📞 +91-7738805577</a> */}
          {auth.length > 0 && (
            <button className="drawer-logout-btn" onClick={handleLogout}>Logout {auth}</button>
          )}
          <div className="drawer-social">
            <a href="https://www.facebook.com/profile.php?id=61567726026527&mibextid=ZbWKwL"><i className="fab fa-facebook-f"></i></a>
            <a href="https://www.instagram.com/al.qaim_welfare/profilecard/?igsh=OXpjZ3Y3bTExbnE3"><i className="fab fa-instagram"></i></a>
            <a href="https://www.threads.net/@al.qaim_welfare?invite=0"><i className="fab fa-threads"></i></a>
            <a href="https://www.youtube.com/@AlQaimWelfareFoundation?target=_blank"><i className="fab fa-youtube"></i></a>
            <a href="https://whatsapp.com/channel/0029Vb8U49IG3R3b3NaFGv3c?target=_blank"><i className="fab fa-whatsapp"></i></a>
          </div>
        </div>
      </div>
    </div>
  );
}